import InviteUserModal from './InviteUserModal.Container';

export default InviteUserModal;
